import {
  Client,
  ClientFile,
  Equipment,
  EquipmentUsage,
  Facility,
  TClientFileId,
  TClientId,
  TEquipmentId,
  TEquipmentUsageId,
  TFacilityId,
  TUserId,
  User,
} from '/src/lib/models';

export type TModelId = TClientId | TFacilityId | TEquipmentId | TEquipmentUsageId | TUserId | TClientFileId;

export enum ModelName {
  Client = 'Client',
  ClientFile = 'ClientFile',
  Facility = 'Facility',
  Equipment = 'Equipment',
  EquipmentUsage = 'EquipmentUsage',
  User = 'User',
}

export type Model = Client | ClientFile | Facility | Equipment | EquipmentUsage | User;
